/**
 * Der Titel, den public/index.html mitbringt, und ein kleiner Haken, um ihn
 * pro Seite zu setzen.
 *
 * Noetig, seit die Blogseiten vorgerendert werden (client/scripts/
 * prerender-blog.js): Frueher stand in jeder ausgelieferten Datei derselbe
 * Standardtitel, und eine Seite konnte ihn beim Verlassen einfach
 * zuruecksetzen. Jetzt bringt jede Artikeldatei ihren eigenen Titel mit –
 * wer den beim Verlassen wiederherstellt, laesst den Artikeltitel auf der
 * naechsten Seite stehen.
 */
import { useEffect } from "react";

export const STANDARD_TITEL =
  "EsGehtMirGut.ch – täglich wissen, dass es den Eltern gut geht";

/** Setzt den Titel und faellt beim Verlassen auf den Standardtitel zurueck. */
export function useSeitenTitel(titel) {
  useEffect(() => {
    if (!titel) return undefined;
    document.title = titel;
    return () => {
      document.title = STANDARD_TITEL;
    };
  }, [titel]);
}
